<template>
  <div class="query-header">
    <el-row
      :gutter="20"
    >
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          style="width: 100%"
          v-model="ruleId"
          placeholder="规则名称"
          clearable
          filterable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in pushList"
            :key="index"
            :label="item.ruleName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          style="width: 100%"
          v-model="type"
          placeholder="账号类型"
          clearable
          filterable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in typelist"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-input
          v-model="name"
          style="width: 100%"
          placeholder="客户姓名"
          clearable
        ></el-input>
      </el-col>
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-input
          v-model="mt4Id"
          @input="loginInput"
          placeholder="账号"
          clearable
        ></el-input>
      </el-col>
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          class="header-item"
          style="width: 100%"
          placeholder="状态"
          v-model="status"
          clearable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in statusList"
            :key="index"
            :label="item.name"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-col>
      <span
        style="display:inline-block;width: 10px"></span>
      <vs-button
        type="info"
        v-if="isAuth('wx:mt4Receiver:list')"

        class="search-btn btn box-item"
        @click="searchHandle"
      >查询</vs-button>
      <span
        style="display:inline-block;width: 10px"></span>
      <vs-button
        v-if="isAuth('wx:mt4Receiver:save')"
        class="add-btn btn box-item"
        @click="addHandle"
      >新增</vs-button>
      <span
        style="display:inline-block;width: 10px"></span>
      <vs-button
        v-if="isAuth('wx:mt4Receiver:delete')"
        :disabled="selected.length < 1"
        class="mutil-btn "
        @click="deleteHandle"
      >批量删除</vs-button>
    </el-row>
  </div>
</template>

<script>
import { limitInt } from '@/utils/validate'
import { mapGetters } from 'vuex'
export default {
  name: "queryHeader",
  props: {
    pushList: {
      type: Array,
      default(){
        return [];
      }
    },
    selected: {
      type: Array,
      default(){
        return [];
      }
    },
  },
  data() {
    return {
      ruleId: '',
      name: '',
      mt4Id: '',
      status: '',
      statusList:[
        {key:0,name:'禁用'},
        {key:1,name:'启用'}
      ],
      typelist:[
        {value:1,label:"Login(MT4账号)"},
        {value:2,label:"Metaquotes ID(MT4客户端ID)"}
      ]
    }
  },
  computed: {
    ...mapGetters(['realMobile']),
  },
  created(){
  },
  methods: {
    loginInput(value){
      this.mt4Id =  limitInt(value);
    },
    toQuery(){
      this.$emit('toQuery');
    },
    searchHandle(){
      this.$emit('toQuery');
    },
    addHandle(){
      this.$emit('add');
    },
    deleteHandle(){
      this.$emit('delete');
    },
  },
}
</script>

<style lang="scss" scoped>
.query-header {
  .header-sub-item {
    width: 100%;
  }
}
</style>
